import PictureCard from './PictureCard'
export default PictureCard
